import React from "react";
import "../styles/theme.css"; // Archivo CSS para los estilos

const Banner = () => {
  return (
    <div className="banner-container">
        <img
            alt=""
            src="/adser_logo.png"
            width="200"
            height="80"
            />
    </div>
  );
};

export default Banner;